export function getEnvProperty(propertyName: string): string {
  // @ts-ignore: This is a global mecanism to handle env properties in each environment
  if (window?.environment && window.environment[propertyName]) {
    // @ts-ignore: This is a global mecanism to handle env properties in each environment
    return window.environment[propertyName]
  } else {
    return (import.meta.env[propertyName] as string) ?? ""
  }
}

export const PROPERTIES = {
  VITE_APP_NOINDEX: "VITE_APP_NOINDEX",
  VITE_APP_ENVIRONMENT: "VITE_APP_ENVIRONMENT",
  VITE_APP_API_URL: "VITE_APP_API_URL",
  VITE_APP_AWS_REGION: "VITE_APP_AWS_REGION",
  VITE_APP_USER_POOL_ID: "VITE_APP_USER_POOL_ID",
  VITE_APP_USER_POOL_WEB_CLIENT_ID: "VITE_APP_USER_POOL_WEB_CLIENT_ID",
  VITE_APP_COOKIE_STORAGE_DOMAIN: "VITE_APP_COOKIE_STORAGE_DOMAIN",
  VITE_APP_BASE_URL: "VITE_APP_BASE_URL",
  VITE_APP_COOKIE_SECURE: "VITE_APP_COOKIE_SECURE",
  VITE_APP_WASM_PATH: "VITE_APP_WASM_PATH",
  VITE_APP_FEATURE_DELETE_RSEE: "VITE_APP_FEATURE_DELETE_RSEE",
  VITE_APP_RECAPTCHA_SITE_KEY: "VITE_APP_RECAPTCHA_SITE_KEY",
  VITE_APP_KAIRNIAL_DASHBOARD_URL: "VITE_APP_KAIRNIAL_DASHBOARD_URL",
}
